import { push } from 'connected-react-router';

import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';
import { hideAddFormModal } from 'actions/forms/addFormModal';

export const TAKE_QUEUE_ITEM_REQUEST = 'TAKE_QUEUE_ITEM_REQUEST';
export const TAKE_QUEUE_ITEM_SUCCESS = 'TAKE_QUEUE_ITEM_SUCCESS';
export const TAKE_QUEUE_ITEM_FAILURE = 'TAKE_QUEUE_ITEM_FAILURE';

function request() {
  return {
    type: TAKE_QUEUE_ITEM_REQUEST,
  };
}

function reject(error) {
  return {
    type: TAKE_QUEUE_ITEM_FAILURE,
  };
}

export function takeQueueItem(workflow, id, accountId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .takeQueueItem(workflow, id)
      .then((response) => {
        if (workflow === 'form') {
          if (response.data) {
            dispatch(hideAddFormModal());
            const redirectUrl = accountId ? `${ response.data }?account=${ accountId }` : response.data;
            return dispatch(push(redirectUrl));
          }
        }

        return null;
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
